import React from "react";
import { FaFacebookF, FaTwitter, FaInstagram, FaMapMarkerAlt, FaEnvelope, FaPhoneAlt, FaCircle, FaDotCircle } from "react-icons/fa";
import "./footer.css";
import logo from "../../assets/logos/White-Logo-01.png"

function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-container">
        {/* Left Section */}
        <div className="footer-about">
          <img src={logo} alt="REDITE Logo" className="footer-logo" /> 
          <p>
            At REDITE, we don’t just build websites – we create digital identities
            that elevate your brand. With striking visuals and seamless functionality,
            we make your site an engaging experience that turns visitors into loyal
            customers. Let’s bring your brand to life online!
          </p>
        </div>

        {/* Useful Links */}
        <div className="footer-links">
          <h3>Useful Links</h3>
          <ul>
            <li><a href="/aboutus"><FaDotCircle style={{ color: "#ff2c2c", marginRight: "8px" }} />  About Us</a></li>
            <li><a href="/service"> <FaDotCircle style={{ color: "#ff2c2c", marginRight: "8px" }} />Services</a></li>
            {/* <li><a href="/team"> <FaDotCircle style={{ color: "#ff2c2c", marginRight: "8px" }} />Our Team</a></li> */}
            <li><a href="/"> <FaDotCircle style={{ color: "#ff2c2c", marginRight: "8px" }} />Testimonials</a></li>
            <li><a href="/faq"><FaDotCircle style={{ color: "#ff2c2c", marginRight: "8px" }} />FAQ</a></li>
            <li><a href="/contactus"><FaDotCircle style={{ color: "#ff2c2c", marginRight: "8px" }} />Contact Us</a></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-contact">
          <h3>Contact Info</h3>
          <p><FaMapMarkerAlt style={{ color: "#ff2c2c", marginRight: "8px" }} /> No: 21 Vinayaga Nagar, Okkiyam Thoraipakkam, Chennai - 97</p>
          <p><FaEnvelope style={{ color: "#ff2c2c", marginRight: "8px" }}  /> redite.com@gmail.com</p>
          <p><FaPhoneAlt style={{ color: "#ff2c2c", marginRight: "8px" }}  /> 044-3169 5917</p>
        </div>

        {/* Social Icons */}
        <div className="footer-social">
          <h3>Follow Us On</h3>
          <div className="social-icons">
            <a href="#"><FaFacebookF /></a>
            <a href="#"><FaTwitter /></a>
            <a href="#"><FaInstagram /></a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>Redite copyright © 2024. All Rights Reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
